import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { Form, Formik } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { useOnboardingZipCodePersistentData } from 'src/app/hooks/feature_data/useOnboardingZipCodePersistentData';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import { getStarted, home } from 'src/app/router/paths';
import { setCurrentOnboardingStep, setOnboardingFormValues } from 'src/app/state/actions/onBoardingFlow';
import { useDispatch } from 'src/app/state/store';

import { OnboardingZipCode } from '../../OnboardingZipCode';
import { STEP_NAME } from '../../StepLayout/consts';
import { ButtonContainer, StyledButton } from '../../styles';

export const WelcomeStep = () => {
  useSegmentTrack(UNIFIED.viewOnboardingDeliveryAreaEligibilityForm);
  const { push } = useHistory();
  const { replace } = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentOnboardingStep(STEP_NAME.WELCOME));
  }, []);

  const { onboardingZipCodePersistentData } = useOnboardingZipCodePersistentData();
  const defaultZipCode = onboardingZipCodePersistentData?.zipCode || '';

  return (
    <Step
      title={`Check if we deliver to you`}
      text={`We're the smarter, simpler, kinder pharmacy. To get started, let's check your delivery zip.`}
      handlePrev={() => replace(home.toPath())}
    >
      <Formik
        initialValues={{ zipCode: defaultZipCode }}
        validationSchema={Yup.object().shape({
          zipCode: Yup.string().required('').min(5, '').label('Zip code'),
        })}
        onSubmit={(_, { setSubmitting }) => {
          try {
            const { zipCode, longitude, latitude, isDeliverable } = onboardingZipCodePersistentData || {};
            dispatch(
              setOnboardingFormValues({
                zipCode: zipCode || '',
                isZipCodeDeliverable: isDeliverable || false,
                longitude: longitude !== undefined ? longitude : '',
                latitude: latitude !== undefined ? latitude : '',
              })
            );
            if (isDeliverable) {
              push(`${getStarted.route}?step=contact`);
            } else {
              push(`${getStarted.route}?step=join_waitlist`);
            }
          } catch (e) {
            console.error('Error submitting form', e);
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting, values }) => (
          <Form>
            <OnboardingZipCode name="zipCode" defaultValue={defaultZipCode} id="onboarding_zip_code" />
            <ButtonContainer smallMarginTop={true}>
              <StyledButton
                size="medium"
                disabled={isSubmitting || values.zipCode.length < 5}
                type="submit"
                style={'capsuleBlue50'}
              >
                Continue
              </StyledButton>
            </ButtonContainer>
          </Form>
        )}
      </Formik>
    </Step>
  );
};
